import type { Ref } from "react";
import { Slot, Slottable } from "@radix-ui/react-slot";
import classNames from "classnames";
import styles from "./Button.module.scss";
import type { ButtonProps } from "./Button.types";

export type { ButtonProps, ButtonSize } from "./Button.types";

const Button = ({
    className,
    variant,
    size: sizeProp,
    asChild = false,
    block = false,
    iconOnly,
    leftIcon,
    rightIcon,
    labelStyle,
    children,
    ref,
    ...props
}: ButtonProps & { ref?: Ref<HTMLButtonElement> }) => {
    const size = sizeProp ?? "md";
    const Comp = asChild ? Slot : "button";

    const buttonClass = classNames(
        styles.button,
        styles[variant],
        styles[size],
        {
            [styles.ghostXsMedium]:
                variant === "ghost" && labelStyle === "xs-medium",
            [styles.iconOnly]: iconOnly,
            [styles.block]: block,
        },
        className,
    );

    return (
        <Comp className={buttonClass} ref={ref} {...props}>
            {/* The slot wrappers are what let the stylesheet tell the
                    two sides apart: a lone chip is both :first-child and
                    :last-child, so side-aware padding needs a named slot. */}
            {leftIcon == null ? null : (
                <span className={styles.leftSlot}>{leftIcon}</span>
            )}
            {asChild ? <Slottable>{children}</Slottable> : children}
            {rightIcon == null ? null : (
                <span className={styles.rightSlot}>{rightIcon}</span>
            )}
        </Comp>
    );
};

export { Button };
